(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-recommendations"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('category-recommendations')) {
  customElements.define('category-recommendations', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('.rca-rail');
      this.controls = this.querySelector('.rca-controls');
      if (!this.rail || !this.controls) return;
      this.update = () => {
        const maxScroll = this.rail.scrollWidth - this.rail.clientWidth;
        this.controls.hidden = maxScroll <= 2;
        this.querySelector('[data-step="-1"]').disabled = this.rail.scrollLeft <= 2;
        this.querySelector('[data-step="1"]').disabled = this.rail.scrollLeft >= maxScroll - 2;
      };
      this.navigate = event => {
        const button = event.target.closest('button[data-step]');
        if (!button || !this.contains(button)) return;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.rail.scrollBy({left: Number(button.dataset.step) * this.rail.clientWidth, behavior: reduced ? 'auto' : 'smooth'});
      };
      this.addEventListener('click', this.navigate);
      this.rail.addEventListener('scroll', this.update, {passive: true});
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.rail);
      this.update();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.navigate);
      this.rail?.removeEventListener('scroll', this.update);
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
